// extracted by mini-css-extract-plugin
export default {"history-rewards-skeleton":"styles_history-rewards-skeleton__fkzr8","shimmer":"styles_shimmer__WzZXC"};